import axios from 'axios';

import { toApiDateTime } from '../utils/dateUtils';

const API_URL = process.env.REACT_APP_API_URL;

const updateUser = async ({ userId, updateData }) => {
  const payload = {
    ...updateData
  };

  if (updateData.dateOfBirth) payload.dateOfBirth = toApiDateTime(payload?.dateOfBirth);

  const response = await axios.put(
    `${API_URL}/users/${userId}`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return response.data;
};

const inviteAdmin = async ({ email, fullName }) => {
  const response = await axios.post(`${API_URL}/users/invite-admin`, {
    email,
    fullName
  });

  return response.data;
};

const deleteAdmin = async (userId) => {
  const response = await axios.delete(`${API_URL}/users/${userId}`);

  return response.data;
};

const userService = {
  updateUser,
  inviteAdmin,
  deleteAdmin
};

export default userService;
